import React, { useEffect, useRef } from "react";
import styled from "styled-components";

const FormWrapper = styled.div`
  max-width: 470px;
`;

const Form = ({ id, formId, trackingId, v3 }) => {
  const ref = useRef(null);

  useEffect(() => {
    const s = document.createElement("script");
    s.id = "form-generator";
    s.dataset.scriptName = "form-generator";
    s.dataset.formId = formId;
    s.dataset.formGeneratorContainerId = id;
    s.dataset.formGeneratorAutoload = true;
    s.defer = true;
    s.async = true;
    s.type = "text/javascript";
    if (v3) {
      s.src = `https://${process.env.GATSBY_FG_DOMAIN}/fg.js`;
    } else {
      s.src = `https://${process.env.GATSBY_FG_DOMAIN}/edu-form-generator.js`;
    }

    if (!document.getElementById(s.id)) {
      ref.current.appendChild(s);
    }
  });

  return (
    <FormWrapper ref={ref}>
      <div
        id={id}
        data-tracking-id={trackingId}
        data-ep_position="0"
        data-ep_type="fg"
      ></div>
    </FormWrapper>
  );
};

export default Form;
